import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001/api';

const AdminInvoice = () => {
  const navigate = useNavigate();
  
  const [invoiceData, setInvoiceData] = useState({
    invNumber: `KAP-${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}-0001`,
    invDate: new Date().toISOString().split('T')[0],
    dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    customerName: '',
    customerEmail: '',
    customerPhone: '',
    customerCompany: '',
    plan: 'Kasango AI Pro',
    term: '1-Year License',
    qty: 1,
    unitPrice: 13000.00,
    discount: 0.00,
    currency: 'ZAR'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGenerateInvoice = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(
        `${API}/invoices/create`,
        invoiceData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      const invoiceId = response.data.id;
      const shareableLink = `${window.location.origin}/invoice/${invoiceId}`;
      
      // Show shareable link to admin
      const copyLink = window.confirm(
        `Invoice created successfully!\n\nShareable Link:\n${shareableLink}\n\nClick OK to copy link and view invoice.`
      );
      
      if (copyLink) {
        navigator.clipboard.writeText(shareableLink);
        alert('Link copied to clipboard!');
      }
      
      // Navigate to invoice
      navigate(`/invoice/${invoiceId}`);
    } catch (err) {
      console.error('Error creating invoice:', err);
      alert('Failed to create invoice. Please try again.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0a0a0a',
      color: '#fff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      padding: '2rem 1rem'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: '#1a1a1a',
        borderRadius: '12px',
        padding: '2rem',
        border: '1px solid #333'
      }}>
        <div style={{ marginBottom: '2rem', borderBottom: '2px solid #00FF7F', paddingBottom: '1rem' }}>
          <h1 style={{ margin: 0, fontSize: '28px', fontWeight: '300' }}>Create Kasango AI Invoice</h1>
          <p style={{ margin: '0.5rem 0 0 0', color: '#888', fontSize: '14px' }}>
            Fill in customer details to generate a professional invoice
          </p>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); handleGenerateInvoice(); }}>
          {/* Invoice Details */}
          <div style={{ marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '16px', color: '#00FF7F', marginBottom: '1rem' }}>Invoice Details</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Invoice Number
                </label>
                <input
                  type="text"
                  name="invNumber"
                  value={invoiceData.invNumber}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Invoice Date
                </label>
                <input
                  type="date"
                  name="invDate"
                  value={invoiceData.invDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Due Date
                </label>
                <input
                  type="date"
                  name="dueDate"
                  value={invoiceData.dueDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Customer Details */}
          <div style={{ marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '16px', color: '#00FF7F', marginBottom: '1rem' }}>Customer Details</h3>
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Full Name *
                </label>
                <input
                  type="text"
                  name="customerName"
                  value={invoiceData.customerName}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    name="customerEmail"
                    value={invoiceData.customerEmail}
                    onChange={handleChange}
                    required
                    placeholder="john@example.com"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      backgroundColor: '#222',
                      border: '1px solid #333',
                      borderRadius: '6px',
                      color: '#fff',
                      fontSize: '14px'
                    }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                    Phone *
                  </label>
                  <input
                    type="tel"
                    name="customerPhone"
                    value={invoiceData.customerPhone}
                    onChange={handleChange}
                    required
                    placeholder="+27 12 345 6789"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      backgroundColor: '#222',
                      border: '1px solid #333',
                      borderRadius: '6px',
                      color: '#fff',
                      fontSize: '14px'
                    }}
                  />
                </div>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Company (Optional)
                </label>
                <input
                  type="text"
                  name="customerCompany"
                  value={invoiceData.customerCompany}
                  onChange={handleChange}
                  placeholder="Company Name"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Product Details */}
          <div style={{ marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '16px', color: '#00FF7F', marginBottom: '1rem' }}>Product Details</h3>
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Plan
                </label>
                <select
                  name="plan"
                  value={invoiceData.plan}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                >
                  <option value="Kasango AI Pro">Kasango AI Pro</option>
                  <option value="CashBet AI">CashBet AI</option>
                  <option value="Ghatti Academy">Ghatti Academy</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Term
                </label>
                <select
                  name="term"
                  value={invoiceData.term}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                >
                  <option value="1-Year License">1-Year License</option>
                  <option value="6-Month License">6-Month License</option>
                  <option value="Lifetime License">Lifetime License</option>
                </select>
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Currency
                </label>
                <select
                  name="currency"
                  value={invoiceData.currency}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                >
                  <option value="ZAR">ZAR</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Unit Price
                </label>
                <input
                  type="number"
                  name="unitPrice"
                  value={invoiceData.unitPrice}
                  onChange={handleChange}
                  step="0.01"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '0.5rem' }}>
                  Quantity
                </label>
                <input
                  type="number"
                  name="qty"
                  value={invoiceData.qty}
                  onChange={handleChange}
                  min="1"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    backgroundColor: '#222',
                    border: '1px solid #333',
                    borderRadius: '6px',
                    color: '#fff',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Preview Totals */}
          <div style={{ 
            backgroundColor: '#222', 
            padding: '1.5rem', 
            borderRadius: '8px', 
            marginBottom: '2rem',
            border: '1px solid #333'
          }}>
            <h3 style={{ fontSize: '14px', color: '#888', marginBottom: '1rem' }}>Invoice Summary</h3>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', fontSize: '14px' }}>
              <span>Subtotal:</span>
              <span>{invoiceData.currency} {(invoiceData.unitPrice * invoiceData.qty).toFixed(2)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', fontSize: '14px' }}>
              <span>VAT (15%):</span>
              <span>{invoiceData.currency} {(invoiceData.unitPrice * invoiceData.qty * 0.15).toFixed(2)}</span>
            </div>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              paddingTop: '0.75rem', 
              borderTop: '1px solid #333',
              fontSize: '18px',
              fontWeight: '600',
              color: '#00FF7F'
            }}>
              <span>Total Due:</span>
              <span>{invoiceData.currency} {(invoiceData.unitPrice * invoiceData.qty * 1.15).toFixed(2)}</span>
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: '1rem' }}>
            <button
              type="button"
              onClick={() => navigate('/admin/dashboard')}
              style={{
                flex: 1,
                padding: '0.875rem',
                backgroundColor: '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                flex: 2,
                padding: '0.875rem',
                backgroundColor: '#00FF7F',
                color: '#000',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              Generate Invoice →
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminInvoice;
